import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import DownloadSection from './components/DownloadSection';
import HotArticlesSection from './components/HotArticlesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://www.example.com/#organization',
      name: '黄瓜视频',
      alternateName: '黄瓜视频App',
      url: 'https://www.example.com',
      slogan: '记录美好，分享快乐',
      description: '黄瓜视频成立于2022年，是一家专注于短视频领域的互联网科技公司，提供海量原创短视频内容和流畅播放体验。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'support@huanggua-video.com',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://www.example.com/#website',
      url: 'https://www.example.com',
      name: '黄瓜视频App官方网站',
      inLanguage: 'zh-CN',
      publisher: { '@id': 'https://www.example.com/#organization' },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://www.example.com/#webpage',
      url: 'https://www.example.com',
      name: '黄瓜视频App官方下载与使用指南',
      isPartOf: { '@id': 'https://www.example.com/#website' },
      about: { '@id': 'https://www.example.com/#organization' },
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'FAQPage',
      '@id': 'https://www.example.com/#faq',
      mainEntity: [
        {
          '@type': 'Question',
          name: '黄瓜视频App在哪里可以下载？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '黄瓜视频App可通过官方网站、苹果App Store、以及主流安卓应用市场（华为应用市场、小米应用商店、应用宝等）进行下载。',
          },
        },
        {
          '@type': 'Question',
          name: '黄瓜视频App是否免费使用？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '黄瓜视频App基础功能完全免费，包括浏览视频、点赞评论、关注创作者等核心功能。部分高级创作工具和专属内容可能需要订阅会员服务。',
          },
        },
        {
          '@type': 'Question',
          name: '如何注册黄瓜视频App账号？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '打开App后点击"我的"-"注册/登录"，支持手机号一键注册、微信授权登录、Apple ID登录（iOS）等多种方式。',
          },
        },
        {
          '@type': 'Question',
          name: '黄瓜视频App支持哪些设备？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '黄瓜视频App目前支持iOS 13.0及以上版本的iPhone设备，以及Android 8.0及以上版本的安卓手机和平板设备。',
          },
        },
        {
          '@type': 'Question',
          name: '下载的视频可以离线观看吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '可以。黄瓜视频App支持视频离线缓存功能，在WiFi环境下将喜欢的视频下载到本地，随时随地离线观看。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="黄瓜视频App官方下载与使用指南 - 海量原创短视频，畅享流畅播放体验"
        description="黄瓜视频App是一款深受用户喜爱的短视频应用，提供海量原创内容、简洁操作界面与流畅播放体验。本页详细介绍黄瓜视频App的核心功能、下载安装步骤、常见问题解答及使用技巧，帮助新老用户快速上手，尽享优质视频内容。"
        keywords="黄瓜视频app,黄瓜视频app下载,黄瓜视频app安装教程,黄瓜视频app最新版本,黄瓜视频app官方入口,黄瓜视频app使用技巧,黄瓜视频app常见问题"
        canonicalUrl="https://www.example.com/"
        ogTitle="黄瓜视频App官方下载与使用指南 - 海量原创短视频，畅享流畅播放体验"
        ogDescription="黄瓜视频App是一款深受用户喜爱的短视频应用，提供海量原创内容、简洁操作界面与流畅播放体验。下载黄瓜视频App，即刻畅享精彩短视频世界！"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <DownloadSection />
        <HotArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}